import { createFileRoute } from "@tanstack/react-router";
import { BankingProviders } from "@/components/Banking/Providers";

function RouteComponent() {
  return <BankingProviders />;
}

export const Route = createFileRoute("/_authenticated/banking-providers/")({
  component: RouteComponent,
  staticData: { page: "banking" },
});
